<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormulario" name="nomFormuvalidarTasalario">
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOCICLO.LBL_MODALIDAD' | translate }}</label>
          <p-dropdown disableTab  id="idModalidad" name="nomModalidad" [options]="lisModalidad"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                       formControlName="idModalidad"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModalidad.invalid">
            {{ 'PERFILRIESGOCICLO.LBL_MODALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOCICLO.LBL_CICLO' | translate }}</label>
          <p-dropdown disableTab  id="idCiclo" name="nomCausal" [options]="lisCiclos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                       formControlName="idCiclo"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCiclo.invalid">
            {{ 'PERFILRIESGOCICLO.LBL_CICLO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submitted && llaveExiste">
            {{ 'PERFILRIESGOCICLO.MSG_ERRORLLAVE' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOCICLO.LBL_PUNTODISMINUCION' | translate }} (%)</label>
          <input type="text" pInputText id="idPuntoDisminucion"
                 name="nomPuntoDisminucion"
                 autocomplete="off"
                 formControlName="puntosDisminucion"
                 [maxlength]="5" (blur)="validarTasa()"
                 porcentaje-reactive [decimales]="2"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.puntosDisminucion.invalid">
            {{ 'PERFILRIESGOCICLO.LBL_PUNTODISMINUCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="supTasa">
            {{ 'PERFILRIESGOCICLO.MSG_SUPERATASA' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <p-checkbox label="{{ 'PERFILRIESGOTASAS.LBL_INDICADORSUMA' | translate}}" binary="true"
                    id="indicadorSuma"
                    name="nomIndicadorSuma"
                    formControlName="indicadorSuma"></p-checkbox>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                      id="indicador"
                      name="nomIndicador"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{(perCicloSeccionado ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             name="nomCicloFiltro"
             (input)="tciclo.filterGlobal($event.target.value, 'contains')" [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #tciclo [loading]="carRiesgoTasa"
               [value]="lisPerfilesRiesgoCiclos" selectionMode="single" dataKey="idPerfilRiesgoVariacionCiclo"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom"
               [loading]="carRiesgoTasa"
              >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.id}}</td>
            <td>{{row.nombreModalidad}}</td>
            <td>{{row.cicloPerfilRiesgo}}</td>
            <td>{{row.puntosDisminucion}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorSuma" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons" *ngIf="perfil.indicadorManejaCiclos">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-right" label="{{'BTN_SIGUIENTE' | translate }}"
              type="submit" (click)="irSiguiente()"
              pButton></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="ciclo">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
